<template>
	<div class="top" v-show="show">
		<transition name="form-fade" mode="in-out">
			<el-form :inline="true" :model="formInline" class="demo-form-inline" :label-position="labelPosition"
				label-width="100px">
				<el-form-item label="经销商单据号:">
					<el-input v-model="formInline.user" placeholder="请输入" class="input"></el-input>
				</el-form-item>
				<el-form-item label="经销商名称:">
					<el-input v-model="formInline.user" placeholder="请输入" class="input"></el-input>
				</el-form-item>
				<el-form-item label="入库日期:">
					<el-date-picker type="date" placeholder="请选择" v-model="formInline.date1"
						style="width: 140px;margin-right: 5px;"></el-date-picker>
					<span style="color: #999999;font-size: 14px;">-</span>
					<el-date-picker type="date" placeholder="请选择" v-model="formInline.date1"
						style="width: 140px;margin-left: 5px;"></el-date-picker>
				</el-form-item>
				<el-form-item label="产品线:">
					<el-input v-model="formInline.user" placeholder="请输入" class="input"></el-input>
				</el-form-item>
				<el-form-item label="状态:">
					<el-input v-model="formInline.user" placeholder="请输入" class="input"></el-input>
				</el-form-item>
				<el-form-item label="审核日期:">
					<el-date-picker type="date" placeholder="请选择" v-model="formInline.date1"
						style="width: 140px;margin-right: 5px;"></el-date-picker>
					<span style="color: #999999;font-size: 14px;">-</span>
					<el-date-picker type="date" placeholder="请选择" v-model="formInline.date2"
						style="width: 140px;margin-left: 5px;"></el-date-picker>
				</el-form-item>
				<el-form-item label="单据类型:">
					<el-select v-model="formInline.region" placeholder="请选择类型" class="input">
						<el-option label="请选择" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品型号:">
					<el-input v-model="formInline.user" placeholder="请输入" class="input"></el-input>
				</el-form-item>
				<el-form-item label="产品名称:">
					<el-input v-model="formInline.user" placeholder="请输入" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="批号:">
					<el-input v-model="formInline.user" placeholder="请输入" class="input"></el-input>
				</el-form-item>
				<el-form-item class="btngroup">
					<div class="btnreset">
						重置
					</div>
					<div class="btnselect">
						查询
					</div>
					<div class="btns">
						收起
					</div>
				</el-form-item>
			</el-form>
		</transition>
	</div>
</template>

<script>
	export default {
		props: {

		},

		data() {
			return {
				labelPosition: 'right',
				show: false,
				formInline: {
					user: '',
					region: '',
					date1: '',
					date2: ''
				}
			}
		},
		mounted() {
			this.formInline.region = 'shanghai'
			this.show = true
		},
		methods: {

		}
	}
</script>
<style scoped="scoped" lang="less">
	@import "../style/mixin.less";

	.top {
		width: 980px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	}

	.demo-form-inline {
		
		padding-bottom: 10px;
		// height: 223px;
		background-color: #fff;
	}

	.el-form-item {
		margin-left: 10px;
		margin-bottom: 0px;
	}

	.input {
		width: 160px;
		height: 32px;
	}

	.el-form-item {
		margin-top: 15px;
	}

	.btngroup {
		font-size: 14px;
		float: right;

		.btnreset {
			width: 64px;
			height: 32px;
			border: 1px solid #e6e6e6;
			border-radius: 2px;
			text-align: center;
			line-height: 32px;
			display: inline-block;
			cursor: pointer;
			
		}

		.btnselect {
			width: 64px;
			height: 32px;
			border: 1px solid #e6e6e6;
			border-radius: 2px;
			text-align: center;
			line-height: 32px;
			color: #fff;
			background-color: #e71d43;
			display: inline-block;
			margin-left: 10px;
			cursor: pointer;
		}

		.btns {
			// width: 64px;
			// height: 32px;
			border-radius: 2px;
			text-align: left;
			line-height: 32px;
			color: #e71d43;
			display: inline-block;
			margin-left: 10px;
			margin-top: 10px;
			cursor: pointer;
		}
	}
</style>
